import { useState } from "react";
import ConfirmDialogModal from "../confirmDialog";
import DeleteIcon from '@mui/icons-material/Delete';
import { useRemoveSsnMutation } from "../../../../api/drivers";
import { sendSuccessMessage } from "../../../../constants/extras/sendSuccessMsg";
import { sendErrorMessage } from "../../../../constants/extras/errorHandlers";

const DeleteSSN = ({ id, ssn, currentUser, driver }) => {
    const [showDialog, setShowDialog] = useState(false);
    const [removeSsn, { isLoading }] = useRemoveSsnMutation();

    async function handleDelete(){
        try {
            await removeSsn(id).unwrap();
            setShowDialog(false);
            sendSuccessMessage(`SSN removed successfully`);
        } catch (error) {
            console.error("Failed to delete SSN:", error);
            sendErrorMessage(`Failed to delete SSN`);
        }
    }

    return (
        <>
            <div
                style={{
                    display: "flex",
                    gap: '10px',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <span>{ssn}</span>
                {currentUser?.role === "root" && ssn && driver?.branch?.status !== 'ACTIVE' && (
                    <span
                        style={{ cursor: "pointer", display: 'flex' }}
                        onClick={() => setShowDialog(true)}
                        title="Delete SSN"
                    >
                        <DeleteIcon style={{ width: "20px", height: "20px", color: 'red' }} />
                    </span>
                )}
            </div>

            {showDialog && (
                <ConfirmDialogModal
                    title="Delete Driver SSN"
                    bodyText="Are you sure you want to delete the SSN? This action cannot be undone."
                    isOpen
                    isLoading={isLoading}
                    confirmAction={handleDelete}
                    onClose={() => setShowDialog(false)}
                />
            )}
        </>
    )
}

export default DeleteSSN;